import { exportCsvApi } from "../index";
import { ExportTableDataRequest, ExportTableDataResponseDto } from "./dto";


export async function exportTableData(payload: ExportTableDataRequest) {
  return await exportCsvApi.post<ExportTableDataResponseDto>('', payload);
}

export async function getExportTableDataStatus(payload: { id: string }) {
  return await exportCsvApi.get<ExportTableDataResponseDto>(`/status/${payload.id}`);
}
